import PropTypes from "prop-types";
import {
	StyledSelectableUpperUnit,
	StyledSelectableUpperUnitWrapper,
} from "../../../styles/StyledSelectableUpperUnits/StyledSelectableUpperUnit";

const SelectableRadioPerson = ({ data, value, selectedPerson }) => {
	const { firstName, lastName } = data;

	return (
		<StyledSelectableUpperUnit checked={selectedPerson === value}>
			<StyledSelectableUpperUnitWrapper>
				<p>
					{firstName} {lastName}
				</p>
			</StyledSelectableUpperUnitWrapper>
			<input type="radio" name="decisionMember" value={value} defaultChecked={selectedPerson === value} />
			<span className="checkmark"></span>
		</StyledSelectableUpperUnit>
	);
};

export default SelectableRadioPerson;

SelectableRadioPerson.propTypes = {
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	selectedPerson: PropTypes.string,
	data: PropTypes.object,
};
